<div [@routerTransition] class="theme-custom">
    <div class="m-subheader ">
        <div class="row align-items-center">
            <div class="mr-auto col-sm-12 col-md-6">
                <h3 class="m-subheader__title">
                    <span>{{l("Notifications")}}</span>
                </h3>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
                <button class="btn multiActionIcon btn-ct-border capitalize-text" (click)="openNotificationSettingsModal()"><i class="fa fa-cog"></i> {{l("NotificationSettings")}}</button>
                <button class="btn btn-primary capitalize-text" (click)="setAllNotificationsAsRead()"><i class="fa fa-check"></i> {{l("SetAllAsRead")}}</button>
            </div>
        </div>
    </div>
    <div class="m-content">
        <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body">
                <div class="m-form m-form--label-align-right">
                    <div class="row m--margin-bottom-10">
                        <div class="col-8 col-sm-6 col-md-4 col-xl-3">
                            <div class="form-group">
                                <select #TargetValueFilterSelectionCombobox
                                        class="form-control theme-custom"
                                        [(ngModel)]="readStateFilter"
                                        (ngModelChange)="getNotifications()"
                                        name="readStateFilter"
                                        jq-plugin="selectpicker">
                                    <option value="ALL">{{l("All")}}</option>
                                    <option value="UNREAD">{{l("Unread")}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-4 col-sm-6 col-md-8 col-xl-9 text-right">
                            <div class="form-group">
                                <button class="btn multiActionIcon" (click)="getNotifications()"><i class="fa fa-refresh"></i> {{l("Refresh")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <!--<Primeng-TurboTable-Start>-->
                    <div class="primeng-datatable-container notification-table" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable
                                 (onLazyLoad)="getNotifications($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                                 [paginator]="false"
                                 [lazy]="true"
                                 [responsive]="primengTableHelper.isResponsive">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th [style.width.px]="updateUnder500 ? 70 : 130">
                                        {{l('Actions')}}    
                                    </th>
                                    <th>
                                        {{l('Notification')}}
                                    </th>
                                    <th [style.width.px]="updateUnder500 ? 70 : null">
                                        {{ updateUnder500 ? l('Time') : l('CreationTime') }}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit">
                                <tr>
                                    <td [style.width.px]="updateUnder500 ? 70 : 130">
                                        <div class="btn-group dropdown">
                                            <button class="btn btn-sm btn-primary" [attr.title]="!isRead(record) ? l('SetAsRead') : ''" (click)="setAsRead(record)" [disabled]="isRead(record)">
                                                <i class="fa fa-check" *ngIf="isRead(record)" [attr.aria-label]="l('Read')"></i>
                                                <i class="fa fa-circle-o" *ngIf="!isRead(record)" [attr.aria-label]="l('Unread')"></i>
                                            </button>
                                        </div>
                                    </td>
                                    <td>
                                        <span class="ui-column-title">{{l('Notification')}}</span>
                                        <a *ngIf="record.formattedNotification.url" href="{{record.formattedNotification.url}}" class="{{getRowClass(record)}}" [innerHTML]="record.formattedNotification.text"></a>
                                        <span *ngIf="!record.formattedNotification.url" title="{{record.formattedNotification.text}}" class="{{getRowClass(record)}}" [innerHTML]="record.formattedNotification.text"></span>
                                    </td>
                                    <td [style.width.px]="updateUnder500 ? 70 : null">
                                        <span title="{{record.notification.creationTime | momentFormat:'llll'}}" class="{{getRowClass(record)}}">
                                            {{fromNow(record.notification.creationTime)}}
                                        </span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{l('NoData')}}
                        </div>
                        <div class="primeng-paging-container">
                            <p-paginator rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                                         #paginator
                                         (onPageChange)="getNotifications($event)"
                                         [totalRecords]="primengTableHelper.totalRecordsCount"
                                         [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage">
                            </p-paginator>
                            <span class="total-records-count">
                                {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}}
                            </span>
                        </div>
                    </div>
                    <!--<Primeng-TurboTable-End>-->
                </div>
            </div>
        </div>
    </div>
</div>
